import React from "react";

// components
import SideNav from "./components/SideNav";

// new
import Navbar from "./components/Navbar";

import { Toaster } from "sonner";

type ITheme = {
  children: React.ReactNode;
};

const Theme: React.FC<ITheme> = ({ children }) => {
  const [open, setOpen] = React.useState<boolean>(false);

  return (
    <div className="min-h-screen grid grid-cols-[auto,1fr] xl:grid-cols-[auto,1fr] overflow-hidden font-sans">
      <SideNav open={open} />
      <div className="h-screen grid grid-rows-[64px,1fr] bg-customgray">
        <Navbar setOpen={() => setOpen(!open)} open={open} />
        <main className="overflow-x-hidden p-9">
          {children}
          <Toaster position="top-right" closeButton />
        </main>
      </div>
    </div>
  );
};

export default Theme;
